import { useMemo } from 'react'

import { MultiPointMapGeo } from 'src/components/molecules/MultiPointMap/types'

import { GetProjectListingQuery } from 'src/config/generated/graphql'
import { GeoData } from 'src/types/map'

import ProjectMapBase from './ProjectMapBase'

type ProjectMapViewProps = {
  projects: GetProjectListingQuery | undefined
}

const PublicMapView = ({ projects }: ProjectMapViewProps) => {
  const points = useMemo<MultiPointMapGeo[]>(() => {
    if (!projects?.Projects.length) return []

    return projects.Projects.map<MultiPointMapGeo>(project => {
      const geo = JSON.parse(project.Geo || '{}') as GeoData

      return {
        lat: geo?.lat,
        lng: geo?.lng,
        place_id: geo?.place_id,
        info: {
          title: project.Name,
          description: project.Description || '',
          imageUrl: project.Hero || '',
          uri: project.Uri || '',
          value: project.Applications_aggregate.aggregate?.sum?.Approved || 0,
          isFeatured: !!project.FeaturedOn?.length,
          isPublicPage: project.PublicPage
        }
      }
    }).filter(t => !!t.place_id)
  }, [projects])

  return <ProjectMapBase points={points} mapHeight='h-[500px] md:h-[800px]' />
}

export default PublicMapView
